<template>
<div class="chapter">
<div class="inner_page">
<h1 class="CT"><a id="Whoopies"></a>Whoopie Recipes</h1>
<p class="CH-INTRO1">A great whoopie pie should be moist, dense and slightly sticky – the perfect hybrid of cake and cookie, with a generous mouthful of filling in every bite. All of the recipes in this book will make 12 whoopies or 40 mini whoopies.</p>
<h3 class="BHD">The Perfect Whoopie…</h3>
<p class="INTRO1">Making whoopie pies is not difficult but there are a few points to bear in mind to guarantee greatness…</p>
<p class="BOD-BL1-1st">•  Always use the best and freshest ingredients you can.</p>
<p class="BOD-BL1">•  Always bring your ingredients to room temperature before you start baking, to avoid curdling.</p>
<p class="BOD-BL1">•  Always preheat your oven.</p>
<p class="BOD-BL1">•  Make sure your whoopies are just firm to the touch before removing from the oven or they tend to sink after a few minutes.</p>
<p class="BOD-BL1">•  Allow whoopies to cool completely before filling and decorating.</p>
<p class="BOD-BL1">•  Whoopies can be baked in any colour you like by adding some food colouring to the batter (see <span href="#/c11#Techniques" title="Link target outside of Sample">Techniques</span>).</p>
<p class="BOD-BL1">•  If you don’t have whoopie pie tins, you can use baking sheets lined with greaseproof paper. Drop scoops of batter at evenly spaced intervals, but not too close together as the mixture tends to spread.</p>
<p class="BOD-BL1">•  To make mini whoopies, follow your chosen whoopie recipe, but use mini muffin tins and 10ml (2 level tsp) batter in each well. Bake for approximately ten minutes or until they are just firm to the touch.</p>
<p class="BOD-BL1-last">•  Whoopie pies are best eaten fresh but can be stored in an airtight container for up to three days. They can also be frozen for up to a month. For best results, freeze in single layers – once frozen they can be stacked on top of each other in a sealed container for easy storage.</p>
<p class="Image"><img alt="" src="images/_MG_1316_fmt.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c03.vue?b031b5da